import React from "react"
import { Link } from "gatsby"
import tw, { styled } from "twin.macro"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons"
import { faThumbsDown } from "@fortawesome/free-solid-svg-icons"
import CircleScore from "../utilities/circle-score"
import BarScore from "../utilities/bar-score"
import ThumbnailImage from "../utilities/thumbnail-image"

const Wrapper = styled.div`
    ${tw`rounded-md bg-gray-400 m-2 px-2 pb-2 overflow-hidden`}
`

const Container = styled.div`
	${tw`bg-gray-200 container flex flex-row flex-wrap bg-gray-300`}
`

const Title = styled.div`
	${tw`flex flex-row content-center justify-between bg-gray-400 w-full p-2`}
`

const Rank = styled.span`
	${tw`text-orange-400 text-base`}
`

const RankNumber = styled.span`
	${tw`text-orange-400 text-2xl pr-2`}
`

const Name = styled.div`
	${tw`text-2xl font-bold`}
`

const Price = styled.div`
	${tw``}
`

const PriceButton = styled.button`
	${tw`bg-blue-500 hover:bg-blue-700 text-white text-base font-bold py-2 px-4 rounded`}
`

const SummaryWrapper = styled.div`
	${tw`flex flex-col w-1/2 p-4`}
`

const SummaryThumbnail = styled.div`
	${tw`justify-center`}
`

const SummaryText = styled.p`
	${tw`text-black text-lg`}
`

const Ratings = styled.div`
	${tw`flex flex-col content-center w-1/2 p-2 text-xl`}
`

const CriteriaTitle = styled.p`
	${tw`text-black font-bold`}
`

const CriteriaRow = styled.div`
	${tw`flex flex-row content-center justify-between text-base font-bold`}
`

const CriteriaBarRow = styled.div`
	${tw`flex-row pb-3`}
`

const Separator = styled.hr`
    ${tw`w-full m-auto my-2 rounded-md border border-gray-400`}
`

const Pros = styled.div`
	${tw`text-black w-1/2 p-2`}
`

const ProCon = styled.li`
	${tw`text-black text-lg`}
`

const Cons = styled.div`
	${tw`w-1/2 p-2`}
`

const GreenFontAwesomeIcon = styled(FontAwesomeIcon)`
    ${tw`m-1 ml-4 mb-2 text-green-500 text-4xl`}
`

const RedFontAwesomeIcon = styled(FontAwesomeIcon)`
    ${tw`m-1 ml-4 mb-2 text-red-600 text-4xl`}
`

const ProductSummary = ({ i, name, slug, thumbnail, merchantURL, merchant, summary, score, criteriaScoreArray, usageScoreArray, prosArray, consArray }) => {
	return (
        <Wrapper>
		    <Container>
                <Title>
                    <Name>
                        <Link to={slug}>
                            {(i != null) && 
                                <Rank>
                                    #
                                    <RankNumber>
                                        {i + 1}
                                    </RankNumber>
                                </Rank>
                            }
                            {name}
                        </Link>
                    </Name>
                    {merchant && 
                    <Price>
                        <a href={merchantURL} target="_blank" rel="noopener noreferrer">
                            <PriceButton>Check Prices at <u>{merchant}</u></PriceButton>
                        </a>
                    </Price>
                    }
                </Title>
                <SummaryWrapper>
                    <SummaryThumbnail>
                        <ThumbnailImage filename={thumbnail} alt={name} />
                    </SummaryThumbnail>
                    <SummaryText>{summary}</SummaryText>
                </SummaryWrapper>
                <Ratings>
                    <CircleScore score={score} />
                    <CriteriaTitle>Criteria</CriteriaTitle>
                        {criteriaScoreArray.map(criteria =>
                            <>
                                <CriteriaRow>
                                    <div>{criteria.name}</div>
                                    <div>{criteria.score}%</div>
                                </CriteriaRow>
                                <CriteriaBarRow>
                                    <BarScore score={criteria.score} />
                                </CriteriaBarRow>
                            </>
                        )}
                </Ratings>
                <Separator />
                <Pros>
                    <GreenFontAwesomeIcon icon={faThumbsUp} />
                    <ul>{prosArray.map(pro => <ProCon>{pro}</ProCon>)}</ul>
                </Pros>
                <Cons>
                    <RedFontAwesomeIcon icon={faThumbsDown} />
                    <ul>{consArray.map(con => <ProCon>{con}</ProCon>)}</ul>
                </Cons>
		    </Container>
        </Wrapper>
	)
}

export default ProductSummary